export enum ProgramEnum {
  RESET = 'reset',
  RESET_O = 'reset-o',
  PEAR_002A = 'pear-002a',
  EMPTY = '',
}
